import { useCallback } from "react";

export const useColumnManagement = ({
  columnsData,
  reorderColumns,
  setColumnVisibilityModel,
  pinnedColumns,
  setPinnedColumns,
}) => {
  const computePinnedFirstOrder = useCallback((currentOrder, pinnedCols) => {
    if (pinnedCols.length === 0) return currentOrder;
    const pinnedSet = new Set(pinnedCols);
    const unpinned = currentOrder.filter((col) => !pinnedSet.has(col));

    return [...pinnedCols, ...unpinned];
  }, []);

  const handlePinColumn = useCallback(
    (column) => {
      if (pinnedColumns.includes(column)) return;
      const newPinned = [...pinnedColumns, column];

      const currentOrder = columnsData?.map((c) => c.column) ?? [];
      const newOrder = computePinnedFirstOrder(currentOrder, newPinned);

      setPinnedColumns(newPinned);
      reorderColumns(newOrder);
    },
    [
      pinnedColumns,
      columnsData,
      reorderColumns,
      computePinnedFirstOrder,
      setPinnedColumns,
    ]
  );

  const handleUnpinColumn = useCallback(
    (column) => {
      const newPinned = pinnedColumns.filter((c) => c !== column);

      const currentOrder = columnsData?.map((c) => c.column) ?? [];
      const withoutColumn = currentOrder.filter((c) => c !== column);
      const insertIndex = newPinned.length;
      const newOrder = [
        ...withoutColumn.slice(0, insertIndex),
        column,
        ...withoutColumn.slice(insertIndex),
      ];

      setPinnedColumns(newPinned);
      reorderColumns(newOrder);
    },
    [pinnedColumns, columnsData, reorderColumns, setPinnedColumns]
  );

  const handleHideColumn = useCallback(
    (column) => {
      setColumnVisibilityModel((prev) => ({
        ...prev,
        [column]: false,
      }));
    },
    [setColumnVisibilityModel]
  );

  return {
    handlePinColumn,
    handleUnpinColumn,
    handleHideColumn,
  };
};
